import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { FormattedNumber } from '@10xLabs/react-web/components/FormattedNumber'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import Heading from 'components/v2/Heading'
import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { GTInventoryWasteItem } from 'gql/types.generated'

export const WasteItems = ({ items = [] }: { items: GTInventoryWasteItem[] }): ReactElement => {
  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <div>
      {items.length > 0 ? (
        <div>
          <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{items.length}</StyledLink>
        </div>
      ) : (
        0
      )}
      {isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): TSFixMe => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="spanish.inventories.orders.items.title" defaultMessage="Productos" />
            </Heading.H5>
          </Modal.Header>
          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />
                    </Th>
                    <Th>
                      <FormattedMessage id="spanish.waste.list.quantity" defaultMessage="Cantidad" />
                    </Th>
                    <Th>
                      <FormattedMessage id="spanish.waste.list.unitPrice" defaultMessage="Precio unitario" />
                    </Th>
                    <Th>
                      <FormattedMessage id="spanish.waste.list.subtotal" defaultMessage="Total" />
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {items.map((item, index: number): ReactElement => {
                    return (
                      <Tr key={index}>
                        <Td>{item.name}</Td>
                        <Td>
                          <FormattedNumber value={item.quantity} />
                        </Td>
                        <Td>
                          <FormattedPrice value={item.price} />
                        </Td>
                        <Td>
                          <FormattedPrice value={item.subtotal} />
                        </Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  )
}
